import { render, staticRenderFns } from "./BeneficiaryAddStepThree.vue?vue&type=template&id=f6c7bebc&scoped=true&"
import script from "./BeneficiaryAddStepThree.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryAddStepThree.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryAddStepThree.vue?vue&type=style&index=0&id=f6c7bebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c7bebc",
  null
  
)

export default component.exports